import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import Loader from "../../../general/Loader";
import "./ExtensionUnpublishConfirmation.css";


const ExtensionUnpublishConfirmation = ({
    visible,
    extension,
    isProcessing,
    error,
    onConfirm,
    onCancel,
}) => {
    if (!extension) return null;

    return (
        <Dialog
            header="Confirm Unpublish"
            visible={visible}
            style={{ width: "400px" }}
            onHide={onCancel}
            modal
            dismissableMask
            className="extension-unpublish-confirmation"
        >
            {isProcessing && <Loader />}

            <p>
                Are you sure you want to unpublish the extension:{" "}
                <strong>{extension.extensionName}</strong>?
            </p>

            {error && <div className="error-message">{error}</div>}

            <div className="confirmation-actions">
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={onCancel}
                    className="p-button-secondary"
                    disabled={isProcessing}
                />
                <Button
                    label="Yes, Unpublish"
                    icon="pi pi-check"
                    onClick={onConfirm}
                    className="p-button-danger"
                    disabled={isProcessing}
                    autoFocus
                />

            </div>
        </Dialog>
    );
};

ExtensionUnpublishConfirmation.propTypes = {
    visible: PropTypes.bool.isRequired,
    extension: PropTypes.object,
    isProcessing: PropTypes.bool,
    error: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ExtensionUnpublishConfirmation;